// Dependencies
import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

// Component
const CircularSpinner = ({ size = 60 }) => <CircularProgress size={size} thickness={4} />;

// Export
export default CircularSpinner;
